import { createAction, props } from '@ngrx/store';
import { Licencia, LicenciaForm } from '@models/.'
import { ResponseBadRequest } from '@interfaces/.';
import { LicenseFilter } from '@core/services/store/interfaces/license-filter';

export const LICENSE_FIND = createAction('[License] Find', props<{ id: string }>());
export const LICENSE_FIND_ALL = createAction('[License] Find All', (licenseFilter?: LicenseFilter) => ({ ...licenseFilter }));

export const LICENSE_FIND_SUCCESS = createAction('[License] Find Success', props<{ license: Licencia }>());
export const LICENSE_FIND_ALL_SUCCESS = createAction('[License] Find All Success', props<{ licenseList: Licencia[] }>());
export const LICENSE_CREATED_SUCCESS = createAction('[License] Create Success', props<{ license: Licencia|null }>());

export const LICENSE_FAILURE = createAction('[License] Failure', props<{ error: ResponseBadRequest }>());

export const LICENSE_UPDATE_LOADING = createAction('[License] Update Loading', props<{ loading: boolean }>());
export const LICENSE_UPDATE_FORM = createAction('[License] Update Form', props<{ licenseForm: LicenciaForm }>());
export const LICENSE_UPDATE_SELECTED = createAction('[License] Update Selected', props<{ licenseSelected: string[] }>());
export const LICENSE_EDIT_MODE = createAction('[License] Edit Mode', props<{ editMode: boolean, isEditing: boolean }>());
export const LICENSE_UPDATE_ID = createAction('[License] Update Id', props<{ licenseId: string|null }>());

export const LICENSE_CREATE_VIEW = createAction('[License] Create View');
export const LICENSE_UPDATE_VIEW = createAction('[License] Update View', props<{ licenseId: string }>());

export const LICENSE_CREATE = createAction('[License] Create');
export const LICENSE_UPDATE = createAction('[License] Update');
export const LICENSE_REMOVE = createAction('[License] Remove', props<{ id: string }>());

export const LICENSE_CREATE_COMPLETED = createAction('[License] Create Completed');
export const LICENSE_UPDATE_COMPLETED = createAction('[License] Update Completed');
export const LICENSE_REMOVE_COMPLETED = createAction('[License] Remove Completed');
export const LICENSE_FIND_ALL_COMPLETED = createAction('[License] Find All Completed');

export const LICENSE_RESET = createAction('[License] Reset');
export const LICENSE_RESET_FORM = createAction('[License] Reset Form');
export const LICENSE_RESET_ERROR = createAction('[License] Reset Error');
export const LICENSE_CLEAR_STATE = createAction('[License] Clear State');